// extracted by mini-css-extract-plugin
export default {"containerMenu":"style_containerMenu__wzgs6","itemMenu":"style_itemMenu__Tf97Y","link":"style_link__1Kpeh"};